export const BAGS_TO_BLOCKS = 2; // fixed conversion rule: 1 bag = 2 blocks
export const MAX_CAPACITY_BLOCKS = 2; // fixed max capacity for salt level conversion
export function isExportBundle(value) {
    if (!value || typeof value !== 'object')
        return false;
    const v = value;
    if (v.schemaVersion !== 1)
        return false;
    if (typeof v.exportedAt !== 'string')
        return false;
    if (!Array.isArray(v.inventory) || !Array.isArray(v.refills))
        return false;
    // shallow shape checks for inventory
    const invOk = v.inventory.every((i) => i && typeof i === 'object' &&
        typeof i.id === 'string' &&
        typeof i.quantityBags === 'number' &&
        (i.status === 'ordered' || i.status === 'arrived') &&
        typeof i.dateAdded === 'string' &&
        (typeof i.dateArrived === 'string' || i.dateArrived === null));
    if (!invOk)
        return false;
    // shallow shape checks for refills
    const refOk = v.refills.every((r) => r && typeof r === 'object' &&
        typeof r.id === 'string' &&
        typeof r.date === 'string' &&
        typeof r.blocks === 'number' &&
        typeof r.createdAt === 'string');
    if (!refOk)
        return false;
    // optional salt levels array — validate shape if present
    if (v.saltLevels !== undefined) {
        if (!Array.isArray(v.saltLevels))
            return false;
        const slOk = v.saltLevels.every((s) => s && typeof s === 'object' &&
            typeof s.id === 'string' &&
            typeof s.percentage === 'number' &&
            typeof s.date === 'string' &&
            typeof s.createdAt === 'string');
        if (!slOk)
            return false;
    }
    return true;
}
